import './category.component.scss'

const getCheckboxesUrl = (checkboxes) => {
  const checkedCheckboxes = Array.from(checkboxes).filter((checkbox) => {
    return checkbox.checked
  })
  return checkedCheckboxes.reduce((previous, item, index) => {
    if (index === 0) {
      return previous + `${item.value}`
    } else {
      return previous + `+${item.value}`
    }
  }, '')
}
function handleLoadMore() {
  const trigger = document.querySelector('.category__more button')
  if (trigger) {
    // let currentPage = document.querySelector('[data-current-page]').value
    // const totalPages = document.querySelector('[data-total-pages]').value
    // const nextUrl = document.querySelector('[data-next-url]').value
    /*
    if (currentPage >= totalPages) {
      trigger.style.display = 'none'
    }*/
    trigger.addEventListener('click', async (e) => {
      const wrapper = document.querySelector('.category__more')
      wrapper.classList.add('category__more_load')
      document.querySelectorAll('.product-preview').forEach(item=>{
        item.classList.remove('hidden')
      })
      trigger.style.display = 'none'
      trigger.parentNode.style.display = 'none'
      e.preventDefault()
      // currentPage = Number(currentPage) + 1
      // const url = nextUrl.replace(/page=[0-9]+/,'page='+currentPage);
      // try {
      //   const response = await fetch(url)
      //   const rawHtml = await response.text()
      //   const products = document.querySelector('.category__grid')
      //   const responseDom = new DOMParser().parseFromString(rawHtml, 'text/html')
      //   const newProducts = responseDom.querySelectorAll('.product-preview')
      //   products.append(...newProducts)
      //   if (currentPage >= totalPages) {
      //     trigger.style.display = 'none'
      //   }
      // } catch (e) {
      //   console.warn(e)
      // } finally {
      //   wrapper.classList.remove('category__more_load')
      // }
    })
  }
}
function showHideFilterButtons(checkboxes) {
  const buttons = document.querySelectorAll('.filter button')
  if (buttons.length > 0) {
    const activeCheckboxes = Array.from(checkboxes).filter((checkbox) => {
      return checkbox.checked === true
    })
    if (activeCheckboxes.length) {
      buttons.forEach(button => button.style.display = 'block')
    }
  }
}
function handleChangeFilter() {
  const checkboxes = document.querySelectorAll(
    '.filter-item input'
  )
  showHideFilterButtons(checkboxes)
  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      showHideFilterButtons(checkboxes)
      const otherSectionCheckboxes = Array.from(
        checkbox
          .closest('.filter-item')
          .querySelectorAll('input')
      ).filter((checkboxItem) => {
        return checkboxItem !== checkbox
      })
      otherSectionCheckboxes.forEach((checkbox) => {
        checkbox.checked = false
      })
    })
  })
}
const handleResetFilters = () => {
  const resetButton = document.querySelector(
    '.filter__reset button'
  )
  if (resetButton) {
    resetButton.addEventListener('click', () => {
      const propSelectors = document.querySelectorAll(
        'filter-item'
      )
      const checkboxes = document.querySelectorAll(
        '.filter-item input'
      )
      const hiddenItem = document.querySelector(
        '[data-collection-name]'
      )
      propSelectors.forEach((item) => {
        item.classList.remove('is-active')
      })
      checkboxes.forEach((item) => {
        item.checked = false
      })
      window.location.href =
        window.location.origin +
        `/collections/${hiddenItem.value}`
    })
  }
}
const handleApplyFilters = () => {
  const checkboxes = document.querySelectorAll(
    '.filter-item input'
  )
  const hiddenItem = document.querySelector(
    '[data-collection-name]'
  )

  const applyButton = document.querySelector(
    '.filter__apply button'
  )
  if (applyButton) {
    applyButton.addEventListener('click', () => {
      const urlPart = getCheckboxesUrl(checkboxes)
      window.location.href =
        window.location.origin +
        `/collections/${hiddenItem.value}/${urlPart}`
    })
  }
}
handleLoadMore()
handleChangeFilter()
handleApplyFilters()
handleResetFilters()
if(window.location.pathname === '/collections/rock-salt/additives'){
  window.location.assign(window.location.origin + '/collections/treated-rock-salt-additives')
}